import { DataTable } from '../../../../../design-system/data-table/data-table';
import { PayrollRecordView } from '../../../../../types/entity-types';
import {
  NAME_COLUMN_ID,
  payrollSummaryTableColumnDefinition,
  PayrollSummaryTableRow,
} from './payroll-summary-column-definition';

export type PayrollSummaryTableProps = {
  records: PayrollRecordView[];
  onEditPayrollRecord?: (payrollRecordId: string) => void;
};

export const PayrollSummaryTable = ({ records, onEditPayrollRecord }: PayrollSummaryTableProps) => {
  return (
    <DataTable<PayrollSummaryTableRow>
      columns={payrollSummaryTableColumnDefinition}
      data={records}
      className="w-full"
      showPagination={false}
      initialSorting={[
        {
          id: NAME_COLUMN_ID,
          desc: false,
        },
      ]}
      meta={{
        onRowPrimaryAction: onEditPayrollRecord,
      }}
    />
  );
};
